import { Product } from "../product.model";
import { ProductType } from "../enums";
import { BundleData } from "./bundle-data";

export class BundleItem {
  //ALL NUMBERS ARE PERCENTAGES EXCEPT QUANTITY
  public productId: string;
  public name: string;
  public warning: string;
  public instructions: string;
  public type: ProductType;

  public fee: number;
  public price: number;

  get percentageFee(): number {
    return this.fee / 100.0;
  }

  constructor(data?: BundleData) {
    if (data == null) {
      this.fee = 0;
      this.price = 0;
    } else this.fromBundleData(data);
  }

  fromBundleData(data: BundleData): BundleItem {
    this.productId = data.item.productId;
    this.name = data.item.name;
    this.warning = data.item.warning;
    this.instructions = data.item.instructions;
    this.type = data.item.type;
    this.fee = data.item.fee;
    this.price = data.item.price;
    return this;
  }

  setProduct(product: Product): BundleItem {
    this.productId = product.id;
    this.name = product.name;
    this.warning = product.warning;
    this.type = product.productType;
    this.instructions = product.instructions;
    return this;
  }

  setFee(fee: number): BundleItem {
    this.fee = fee;
    return this;
  }

  setPrice(price: number): BundleItem {
    this.price = price;
    return this;
  }

  toAPIRequest() {
    return {
        productId: this.productId,
        fee: this.fee * 100,
        price: this.price * 100,
    }
  }

  load(data: any): BundleItem {
    this.name = data.name;
    this.productId = data.productId;
    this.fee = data.fee / 100;
    this.price = data.price / 100;
    this.instructions = data.instructions;
    this.warning = data.warning;
    this.type = data.type as ProductType;
    return this;
  }

  copy(item: BundleItem): BundleItem {
    this.productId = item.productId;
    this.name = item.name;
    this.instructions = item.instructions;
    this.warning = item.warning;
    this.type = item.type;
    this.price = item.price;
    this.fee = item.fee;
    return this;
  }
}
